<div *ngIf="!!rule">
    <div class="rulesContent">
        <div>
            <div class="rulesInfo">
                <div class="ellipsis">{{ rule.subject }}</div>
                <div>{{ rule.name }}</div>
                <div *ngIf="!!rule.stage">{{ rule.stage.name }}</div>
            </div>
            <div class="rulesDescription ellipsis">{{ rule.description }}</div>
        </div>
        <div (click)="removeRule(rule.id)">
            <span class="fa fa-trash text-danger"></span>
        </div>
    </div>
</div>
